import { Controller } from "@hotwired/stimulus";

// Module-level flag survives across controller disconnect/reconnect
// during Turbo Frame replacement
let restoreFocusToSearch = false;

export default class extends Controller {
  connect() {
    this.timeout = null;
    this.debounceMs = 300;

    // After Turbo Frame replaces content, restore focus to search input
    // if the user was actively typing (flag set by debounceSubmit)
    if (restoreFocusToSearch) {
      restoreFocusToSearch = false;
      const input = this.element.querySelector('input[type="search"]');
      if (input) {
        input.focus();
        input.setSelectionRange(input.value.length, input.value.length);
      }
    }
  }

  // Immediate submit (dropdown filter changes)
  submit() {
    clearTimeout(this.timeout);
    this.element.requestSubmit();
  }

  // Debounced submit (search input — sets flag to restore focus after frame swap)
  debounceSubmit() {
    clearTimeout(this.timeout);
    restoreFocusToSearch = true;
    this.timeout = setTimeout(() => {
      this.element.requestSubmit();
    }, this.debounceMs);
  }

  disconnect() {
    clearTimeout(this.timeout);
  }
}
